import http from '../../http'
export default {
    list: (data) => {
        return http.post('activityservice/activityhonoredguest/list', data)
    },
    add: (data) => {
        return http.post('activityservice/activityhonoredguest/insert', data)
    },
    update: (data) => {
        return http.post('activityservice/activityhonoredguest/update', data)
    },
    del: (data) => {
        return http.post('activityservice/activityhonoredguest/delete', data)
    },
    delAll: (data) => {
        return http.post('activityservice/activityhonoredguest/batchdelete', data)
    },
    import: (data) => {
        return http.post('activityservice/activityhonoredguest/import', data)
    },
    export: (data) => {
        return http.post('activityservice/activityhonoredguest/exportguest', data)
    }
}
